import './index.scss'

import ItemEstoque from '../../components/itemEstoque';
import ModalEstoque from '../../components/modaEstoque';

import { useState } from 'react';

export default function Estoque() {
    const [openModal, setOpenModal] = useState(false);

    function AtivaModal() {
        setOpenModal(true); 
    }

    function FechaModal() {
        setOpenModal(false); 
    }
    return(
        <div className='storage-page'>
            <div className='button-section'>
                <div className='img'>
                    <img className='butterfly' src='/assets/images/estoque/borboleta.png'></img>
                </div>
                <button>Agenda</button>
                <button>Estoque</button>
            </div>


            <div className='container-conteudo'>
                    <div className='storage-search'>
                        <div className='container-procurar'>
                        <div className='text'>
                            <h3>Estoque</h3>
                            <p>Aqui você pode ver todos os itens e sua quantidade do estoque.</p>
                        </div>

                        <div className='search-product'>
                            <div className='search'>
                                <input className='input' type='input-search'></input>
                                <button className='button-search'>Buscar</button>
                            </div>
                            <ModalEstoque isOpen={openModal} closeModal={FechaModal} />
                            <button onClick={AtivaModal} className='new-product'>+ Novo Produto</button>
                        </div>
                        </div>
                        
                    </div>
                    <div className='container-produtos'>

                        <ItemEstoque/>
                        
                    </div>
            </div>
           
        </div>
    );
}